import { components, reducers } from 'linksoft';
import moduleName from './module';
import chart from './chart';
import reducer from './reducer';

components.add('chainage-chart', chart);
reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [chart],
    reducer: reducer
};



// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/index.js